import { useSnackbar } from 'notistack';
import { useState } from 'react';
import axiosInstance from 'src/utils/axios';
import { APIS } from 'src/utils/serviceUrls';
import { Event } from '../../../@types/event';

export const useEvents = () => {
  const [events, setEvents] = useState<Event[]>([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [currentEvent, setCurrentEvent] = useState<Event | undefined>();
  const { enqueueSnackbar } = useSnackbar();

  const getList = async () => {
    const response = await axiosInstance.get(APIS.EVENTS.LIST);
    setEvents(response.data.data);
  };

  const handleEditRow = (selected: Event) => {
    setCurrentEvent(selected);
    setModalOpen(true);
  };

  const handleDeleteRow = async (id: string) => {
    try {
      await axiosInstance.delete(APIS.EVENTS.DELETE(id));
      enqueueSnackbar('Deleted Successfully', { variant: 'success' });
    } catch (error) {
      console.error(error);
      enqueueSnackbar(error?.message || 'Unable to delete program', { variant: 'error' });
    }
  };

  return {
    events,
    modalOpen,
    setModalOpen,
    currentEvent,
    setCurrentEvent,
    getList,
    handleEditRow,
    handleDeleteRow,
  };
};
